import { RechargeRecordInterface } from '../_model/recharge/recharge-record.interface';
import { Injectable } from "@angular/core";

@Injectable()
export class RechargeRecordformer {
    transform(item): RechargeRecordInterface {
        const result: RechargeRecordInterface = {
            id: item.id,
            point: item.name,
            payType: item.payType,
            payment: item.comeFrom,
            date: item.postTime,
            amount: item.gold,
            status: item.status,
        };
        return result;
    }
}
